export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/f421a88e051d022d36bde52c98267d4c.png";